import React from 'react';
import { ResourceProps } from 'react-admin';

// Analíticas, escena Uso. `/holdings` abre la misma pantalla en la escena
// Tenencias: son dos lentes del mismo lugar.
let resourceProps: ResourceProps = {
  name: 'metrics',
  list: React.lazy(() => import(/* webpackChunkName: "c-analiticas" */ '../../console/pages/analiticas')),
};

export default resourceProps;
